// src/backendServices/liveStreamManagment/api_xtreamDirectory.ts
//
// L'annuaire des triplets {server, username, password} Xtream Codes déjà
// employés par un créateur — vit dans admin-api, PAS dans le microservice
// ffmpeg d'une chaîne (cf. listXtreamAccounts dans api_microservice_sources.ts,
// qui lui est propre à UNE chaîne). Sert à préremplir le formulaire de
// création d'une source Xtream sans retaper des identifiants déjà saisis pour
// une autre chaîne du même créateur.

import { API_URLS } from '../urls';

export interface XtreamDirectoryEntry {
  id        : number;
  server    : string;
  username  : string;
  password  : string;
  label     : string | null;
  createdAt : string;
  lastUsedAt: string;
}

/** L'annuaire d'un créateur, du plus récemment employé au plus ancien. */
export const listXtreamDirectory = async (adminId: number): Promise<XtreamDirectoryEntry[]> => {
  const res = await fetch(`${API_URLS.getXtreamDirectory}?admin_id=${adminId}`, { cache: 'no-store' });

  const data = await res.json().catch(() => ([]));

  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);

  return Array.isArray(data) ? data : [];
};

/**
 * Enregistre un triplet dans l'annuaire, ou met à jour l'entrée existante
 * (même server+username pour ce créateur) — jamais de doublon.
 */
export const saveXtreamDirectoryEntry = async (
  adminId : number,
  creds   : { server: string; username: string; password: string; label?: string },
): Promise<XtreamDirectoryEntry> => {
  const res = await fetch(API_URLS.saveXtreamDirectoryEntry, {
    method  : 'POST',
    headers : { 'Content-Type': 'application/json' },
    body    : JSON.stringify({
      admin_id: adminId,
      server  : creds.server,
      username: creds.username,
      password: creds.password,
      label   : creds.label ?? '',
    }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);

  return data as XtreamDirectoryEntry;
};

export const deleteXtreamDirectoryEntry = async (adminId: number, id: number): Promise<void> => {
  const res = await fetch(
    `${API_URLS.deleteXtreamDirectoryEntry.replace('{id}', String(id))}?admin_id=${adminId}`,
    { method: 'DELETE' },
  );

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error ?? `HTTP ${res.status}`);
  }
};
